<template>
  <div>
    <Head :title="$t('global.update') + ' ' +$t('locations.locations') + ' - ' +correctName" />

    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/locations">{{ $t('locations.locations') }}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ correctName }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('locations.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :types="types" />
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy"
          >
            {{ $t('global.delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    types: Array,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        'id': this.data.id,
        'name': this.data.name,
        'types': this.data.types,
        'created_at': this.data.created_at,
        'updated_at': this.data.updated_at,
        'empty_field': !!this.data.empty_field,
        'for_volunteer': !!this.data.for_volunteer,

      }),
    }
  },
  computed: {
    correctName() {
      return this.data.name[this.auth.user.language]
    },
  },
  methods: {
    update() {
      this.form.put(`/locations/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/locations/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/locations/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
